import React from 'react';
import {connect} from "react-redux";
import '../style/detail.css';
import RewardGroupSwitchComponent from "../components/RewardGroupSwitchComponent";

class RewardGroupSwitchContainer extends React.Component {

    render() {
        return this.props.showGroupSwitch ? <RewardGroupSwitchComponent key={this.props.rewardId} switchOptions={this.props.groupSwitchOptions} selectedRewardId={this.props.rewardId} groupSwitchTitle={this.props.groupSwitchTitle}/> : null;
    }

}

export default connect(
    (state) => {
        return {
            showGroupSwitch: state.reward.showGroupSwitch,
            groupSwitchTitle: state.reward.groupSwitchTitle,
            groupSwitchOptions: state.reward.groupSwitchOptions,
            rewardId: state.reward.item ? state.reward.item.id : null
        }
    }
)(RewardGroupSwitchContainer)

